export default "__VITE_ASSET__BQFwMCo8__"